import React, {Component} from 'react';
const { connect } = require('react-redux');

import * as getInfoMain from 'reducers/main';

import {getGenderText, getRoomUserWeight, filterRoomUser} from 'utils/user';

import '../sass/room-user-list.scss';
import Loading from 'components/Loading';
import ProfileLink from "../components/ProfileLink";
import {isSameRoomURL} from "../utils/url";
import isMobile from "ismobilejs";
import { localizeUrl } from '../components/ReactRouterDomLocalized';
import NotFound from '../containers/NotFound';

class RoomUserList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            roomBlocks: {}
        }


    }

    getData() {
        this.props.getRoomsNeo();
        this.props.getPersonalRooms();
    }

    componentDidMount() {
        this.getData();
    }

    toggleRoomBlock(event, roomid) {
        event.preventDefault();

        this.setState({
            roomBlocks: {
                ...this.state.roomBlocks,
                [roomid]: this.state.roomBlocks[roomid] !== undefined ? !this.state.roomBlocks[roomid] : false
            }
        });
    }

    getRoomToggleLink(room) {
        let state = this.state.roomBlocks[room.roomid] !== undefined ? this.state.roomBlocks[room.roomid] : true,
            label = state ? 'collapse' : 'expand';

        return <a href="#" onClick={(event) => this.toggleRoomBlock(event, room.roomid)}>{label}</a>
    }

    getRoomBlockClass(room) {
        let state = this.state.roomBlocks[room.roomid] !== undefined ? this.state.roomBlocks[room.roomid] : true;

        return state ? 'expanded' : 'collapsed';
    }

    getRoomDisplayName(room) {
        return room.creator ? 'My BobTV | ' + room.creator.nick + ' - ' + room.name : room.name;
    }

    maybeOpenRoom(room, windowname, user) {
        let url = localizeUrl(url ? url : room.url);

        let wnd = window.open('', windowname, 'height=678,width=1200,resizable=1,toolbar=0,scrollbars=0');

        // if we just opened the window
        if (wnd && (wnd.closed || (!wnd.document.URL) || (wnd.document.URL.indexOf("about") === 0) || !isSameRoomURL(url, wnd.document.URL))) {
            wnd.location.href = url;
        } else {
            if (isMobile.apple.device) {
                if(wnd) {
                    wnd.close();
                }
                wnd = window.open(url, windowname);
            } else {
                wnd.focus();
                if(user) {
                    wnd.postMessage({action: 'openVideoWindow', ufrag: user.ufrag, roomid: user.roomid}, "*");
                }
            }
        }

        // return the window
        return wnd;
    }

    render() {
        let {rooms, personal_rooms, currentUser} = this.props;

        console.log(this.props);

        let contentBlock;

        if(!currentUser.isOwner()) {
            return <NotFound {...this.props}/>
        }

        if (!rooms || !personal_rooms) {
            contentBlock = <Loading centered>Loading list, please wait...</Loading>
        } else {
            let roomsCombined = [...rooms, ...personal_rooms].map(function (room) {
                room.users = room.users.map(function (user) {
                    user.filtered = filterRoomUser(user, room);
                    user.weight = getRoomUserWeight(user);
                    return user;
                });
                room.users = room.users.sort(function (user1, user2) {
                    return user1.weight > user2.weight ? -1 : 1
                });
                return room;
            });

            contentBlock = (
                roomsCombined.map((room, index) =>
                    <div key={index} className={this.getRoomBlockClass(room)}>
                        <h3>{this.getRoomDisplayName(room)} {this.getRoomToggleLink(room)}</h3>
                        <table>
                            <thead>
                            <tr>
                                <th>nick</th>
                                <th>avatar</th>
                                <th>snapshot</th>
                                <th>gender</th>
                                <th>gift points</th>
                                <th>paused</th>
                                <th>watcher count</th>
                                <th>weight</th>
                            </tr>
                            </thead>
                            <tbody>
                            {!room.users.length && <tr>
                                <td colSpan="8"><em>Room is empty</em></td>
                            </tr>}
                            {room.users.map((user, index2) =>
                                <tr key={index2} className={!user.filtered ? 'filtered' : ''}
                                    title={!user.filtered ? 'user will be hidden' : ''}>
                                    <td><ProfileLink user={user} target="_blank"/></td>
                                    <td><ProfileLink user={user} target="_blank"><img src={user.avatar_url} alt=""/></ProfileLink></td>
                                    <td><img src={user.snapshot} alt="" className="link" onClick={ () => this.maybeOpenRoom(room, 'chat', user) } /></td>
                                    <td>{getGenderText(user)}</td>
                                    <td>{user.gift_points || 0}</td>
                                    <td>{user.paused ? 'pause' : ''}</td>
                                    <td>{user.watcher_count || 0}</td>
                                    <td>{user.weight}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                )
            )
        }



        return (
            <div className="test">

                <div className="rooms-test">
                    <h2>Room user sorting <a href="#" onClick={(event) => { event.preventDefault(); this.getData(); }}>[refresh]</a></h2>

                    {contentBlock}
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        rooms: state.main.rooms,
        personal_rooms: state.main.personal_rooms,
    }),({
        getRoomsNeo: getInfoMain.getRoomsNeo,
        getPersonalRooms: getInfoMain.getPersonalRooms,
    })
)(RoomUserList)



// WEBPACK FOOTER //
// ./src/containers/RoomUserList.js